import { Close, Description } from "@mui/icons-material";
import { Box, IconButton, Typography } from "@mui/material";
import { useCelleraTheme } from "theme/useCelleraTheme";

type FilePreviewProps = {
  file: File;
  onRemove: () => void;
};

const FilePreview: React.FC<FilePreviewProps> = ({
  file,
  onRemove,
}: FilePreviewProps) => {
  const { colors } = useCelleraTheme();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 0.75,
        px: 1.5,
        py: 0.75,
        borderRadius: "8px",
        backgroundColor: colors.background.highlight,
        border: `1px solid ${colors.border.light}`,
        maxWidth: "220px",
      }}
    >
      <Description
        sx={{
          color: colors.text.secondary,
          fontSize: "16px",
          flexShrink: 0,
        }}
      />
      <Typography
        variant="body2"
        sx={{
          fontSize: "13px",
          fontWeight: 400,
          color: colors.text.primary,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          flex: 1,
          minWidth: 0,
        }}
      >
        {file.name}
      </Typography>
      <IconButton
        size="small"
        onClick={onRemove}
        sx={{
          color: colors.text.secondary,
          p: 0.25,
          minWidth: "auto",
          width: "16px",
          height: "16px",
          flexShrink: 0,
          "&:hover": {
            color: colors.text.primary,
            backgroundColor: "transparent",
          },
        }}
      >
        <Close sx={{ fontSize: "14px" }} />
      </IconButton>
    </Box>
  );
};

export default FilePreview;
